import React, { useMemo } from "react";
import { QuoteForm } from "../components/QuoteForm";
import { SafesitePromise } from "./SafesitePromise";
import Container from "./Container";
import Section from "./Section";
import Grid from "../components/Grid";
import styled, { css } from "styled-components";
import randomstring from "randomstring"

const SectionStyles = styled(Section)`
  ${({ ...props }) => css`
    border-top: 60px solid transparent;
    margin-top: -60px;
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    background-clip: padding-box;
    scroll-margin-top: 40px;
  `}
`;

export const navigateToQuoteForm = () => {
  const freeQuoteElement = document.querySelector(".free-quote");

  if (freeQuoteElement) {
    const currentUrlWithoutHash = window.location.href.split('#')[0];
    window.location.replace(`${currentUrlWithoutHash}#${freeQuoteElement.id}`)
  }
}

export const QuoteFormAndSafesitePromise = ({ source }) => {
  const rand = useMemo(() => randomstring.generate(5), []);

  return (
    <SectionStyles id={`${rand}_free-quote`} className="free-quote">
      <Container>
        <Grid equalHeight>
          <Grid item md="8">
            <QuoteForm inline source={source} />
          </Grid>
          <Grid item md="4">
            <SafesitePromise />
          </Grid>
        </Grid>
      </Container>
    </SectionStyles>
  );
};
